// Два конверта ответов бэкенда (api.md):
//  - keyset-листинги: { items, next_cursor } → infiniteQueryOptions
//  - мелкие/поисковые списки без пагинации: { data }

export interface CursorPage<T> {
  items: T[]
  next_cursor: string | null
}

export interface DataEnvelope<T> {
  data: T[]
}

// getNextPageParam для infiniteQueryOptions: пустой/null курсор — конец.
export function nextCursor<T>(page: CursorPage<T>): string | undefined {
  return page.next_cursor ? page.next_cursor : undefined
}

// Плоский список из страниц infinite-query.
export function flattenPages<T>(pages: ReadonlyArray<CursorPage<T>> | undefined): T[] {
  return pages ? pages.flatMap((p) => p.items) : []
}
